export default __webpack_public_path__ + "9803a97f4468f35527d343f9e8f04b48.svg";